import { memo } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { useConnectionStore } from "stores/ConnectionStore";
import { ActionState } from "stores/lib";
import { useUserStore } from "stores/UserStore";

import Sources from "external/sources";

import Loading from "./Loading";
import PossibleSource from "./Source";

// -----------------------------------------------------------------------------

const EnvironmentPossibleSources = memo(function EnvironmentPossibleSources() {
  const [store] = useConnectionStore();
  const [userStore] = useUserStore();

  const possibleSources = Sources.services.filter((s) => {
    if (s.featureFlag) {
      return userStore.user.features & s.featureFlag;
    } else {
      return true;
    }
  });

  //
  switch (true) {
    case store.loadConnections.state === ActionState.IN_PROGRESS:
      return (
        <Grid container spacing={1}>
          <Loading />
        </Grid>
      );

    case possibleSources.length > 0:
      return (
        <Grid container spacing={1}>
          {possibleSources.map((source) => {
            return (
              <PossibleSource
                source={source as any}
                hideDismissButton
                key={source.name}
              />
            );
          })}
        </Grid>
      );

    default:
      return (
        <Typography variant="body1">
          You&apos;ve connected to all available sources.
        </Typography>
      );
  }
});

export default EnvironmentPossibleSources;
